(() => {
  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const slides = Array.from(root.querySelectorAll('[data-v7-home-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-v7-home-dot]'));
    const prev = root.querySelector('[data-v7-home-prev]');
    const next = root.querySelector('[data-v7-home-next]');
    if (slides.length < 2) return;
    let index = 0;
    let timer = null;
    let touchStart = null;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const speed = Math.max(5000, Number(root.dataset.speed) || 7000);
    const autoplay = root.dataset.autoplay === 'true' && !reduce;

    const show = (target) => {
      index = (target + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = null; root.classList.add('is-paused'); };
    const start = () => { if (!autoplay) return; stop(); root.classList.remove('is-paused'); timer = window.setInterval(() => show(index + 1), speed); };
    prev?.addEventListener('click', () => { show(index - 1); start(); });
    next?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach(dot => dot.addEventListener('click', () => { show(Number(dot.dataset.index) || 0); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) start(); });
    root.addEventListener('touchstart', e => { touchStart = e.touches[0]?.clientX ?? null; }, {passive:true});
    root.addEventListener('touchend', e => {
      if (touchStart === null) return;
      const end = e.changedTouches[0]?.clientX ?? touchStart;
      const delta = end - touchStart;
      if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1));
      touchStart = null;
      start();
    }, {passive:true});
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(0);
    start();
  };
  document.querySelectorAll('[data-v7-home-hero]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-v7-home-hero]')));
})();